import React from 'react';
import Navigation from '../../components/layout/Navigation';

const TermsOfServicePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation isAuthenticated={false} />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* IMPORTANT NOTICE */}
        <div className="bg-red-50 border-2 border-red-200 rounded-lg p-6 mb-8">
          <h2 className="text-red-800 font-bold text-xl mb-2">⚠️ LEGAL REVIEW REQUIRED</h2>
          <p className="text-red-700">
            This is a placeholder terms of service. Proper terms must be drafted by legal counsel
            before launch to address minors' use, NCAA compliance, liability limitations, and
            dispute resolution.
          </p>
        </div>

        <h1 className="text-4xl font-display font-bold text-rowing-gray-900 mb-8">
          Terms of Service
        </h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-rowing-gray-600 mb-6">
            <strong>Effective Date:</strong> [TO BE DETERMINED]
            <br />
            <strong>Last Updated:</strong> [TO BE DETERMINED]
          </p>

          <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 mb-8">
            <h3 className="text-lg font-semibold mb-2">Age Requirement</h3>
            <p className="text-sm">
              You must be at least 14 years old to use Glyyd. Users under 18 must have parental
              consent. By using our service, you confirm you meet these requirements.
            </p>
          </div>

          <h2 className="text-2xl font-bold text-rowing-gray-900 mt-8 mb-4">
            Key Terms to Include
          </h2>

          <h3 className="text-xl font-semibold mt-6 mb-3">1. Account Registration</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>Users must be 14+ years old</li>
            <li>Users under 18 require verifiable parental consent</li>
            <li>All information provided must be accurate</li>
            <li>Users are responsible for account security</li>
            <li>One account per person</li>
          </ul>

          <h3 className="text-xl font-semibold mt-6 mb-3">2. Acceptable Use</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>Comply with all NCAA recruitment regulations</li>
            <li>No false or misleading information</li>
            <li>No harassment or inappropriate contact</li>
            <li>Respect intellectual property rights</li>
            <li>No automated access or scraping</li>
          </ul>

          <h3 className="text-xl font-semibold mt-6 mb-3">3. NCAA Compliance</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>Users must follow all applicable NCAA rules</li>
            <li>Platform is not responsible for NCAA violations</li>
            <li>Communication restrictions during dead periods</li>
            <li>Accurate reporting of athletic achievements required</li>
          </ul>

          <h3 className="text-xl font-semibold mt-6 mb-3">4. Privacy and Data Use</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>Data collection and use governed by Privacy Policy</li>
            <li>Parental consent required for minors</li>
            <li>Third-party sharing only with consent</li>
            <li>Users retain ownership of their content</li>
          </ul>

          <h3 className="text-xl font-semibold mt-6 mb-3">5. Content Guidelines</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>Users responsible for content accuracy</li>
            <li>No copyrighted material without permission</li>
            <li>Platform may remove inappropriate content</li>
            <li>Athletic achievements must be verifiable</li>
          </ul>

          <h3 className="text-xl font-semibold mt-6 mb-3">6. Fees and Payments</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>Subscription fees as listed on pricing page</li>
            <li>Automatic renewal unless cancelled</li>
            <li>Refund policy details</li>
            <li>No refunds for NCAA violations</li>
          </ul>

          <h3 className="text-xl font-semibold mt-6 mb-3">7. Limitation of Liability</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>No guarantee of recruitment outcomes</li>
            <li>Not responsible for coach decisions</li>
            <li>Limitation on damages</li>
            <li>No warranty of continuous service</li>
          </ul>

          <h3 className="text-xl font-semibold mt-6 mb-3">8. Termination</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>Either party may terminate at any time</li>
            <li>Immediate termination for violations</li>
            <li>Data retention per Privacy Policy</li>
            <li>Survival of certain provisions</li>
          </ul>

          <h3 className="text-xl font-semibold mt-6 mb-3">9. Dispute Resolution</h3>
          <p className="mb-4">Legal counsel must determine:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Arbitration vs. litigation</li>
            <li>Class action waiver (may not apply to minors)</li>
            <li>Governing law and venue</li>
            <li>Attorney's fees provisions</li>
          </ul>

          <h3 className="text-xl font-semibold mt-6 mb-3">10. Contact Information</h3>
          <p>
            For questions about these terms:
            <br />
            Email: legal@glyyd.com
            <br />
            Phone: [TO BE ADDED]
            <br />
            Mail: [TO BE ADDED]
          </p>

          <div className="bg-rowing-gray-100 rounded-lg p-6 mt-8">
            <h3 className="font-semibold mb-2">Legal Counsel Note</h3>
            <p className="text-sm">
              These terms must be customized to include: specific arbitration provisions
              (considering minors cannot waive certain rights), DMCA procedures, indemnification
              clauses, modification procedures, severability clause, and integration clause. Special
              attention needed for provisions affecting minors.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
